module.exports = __webpack_public_path__ + "assets/img/driver-btn-0f55f9eb.png";